import DeleteOutlineOutlinedIcon from "@mui/icons-material/DeleteOutlineOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { Button, IconButton, Switch, Tooltip } from "@mui/material";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { putPlanById } from "../../../api/broker";
import { useSuperAdminPlans } from "../../../context/SuperAdmin/PlanContext";
import { useAuthContext } from "../../../hooks/Auth";
import { Estado } from "../../../interfaces/SuperAdmin/Others/iDataEstado";
import { iDataPlan } from "../../../interfaces/SuperAdmin/Pages/iDataPlan";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../ui-components/StyledTables";

interface PlanRowProps {
  plan: iDataPlan;
  i: number;
}

export const ProfileRowPlans: React.FC<PlanRowProps> = ({ plan, i }) => {
  const { handleEdit, assignToDeletePlan, selectedOrg } = useSuperAdminPlans();
  const navigate = useNavigate();
  const { canAccess } = useAuthContext();

  const isSuperAdmin = canAccess(["edit:plans", "delete:plans"]);

  const [isActive, setIsActive] = useState(plan.estado === Estado.ACTIVO);

  const toggleActive = async () => {
    const body = { estado: isActive ? Estado.INACTIVO : Estado.ACTIVO };

    try {
      const res = await putPlanById(plan.id_plan, body as any);
      console.log(res);

      if (res.status === 200) {
        setIsActive((prev) => !prev);
        toast.success(
          `Plan ${isActive ? "desactivado" : "activado"} exitosamente`
        );
      } else {
        toast.error(`Error al  ${isActive ? "desactivar" : "activar"} el plan`);
      }
    } catch (error) {
      console.log(error);
      toast.error(`Error al  ${isActive ? "desactivar" : "activar"} el plan`);
    }
  };

  const handleNavigate = () => {
    if (selectedOrg) {
      navigate(`/asistente/plans/${selectedOrg}/${plan.id_plan}`);
    }
  };

  return (
    <StyledTableRow>
      <StyledTableCell sx={{ mb: 2 }}>{i}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>{plan.nombre}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        <Tooltip
          title={
            plan.organizacion &&
            isSuperAdmin &&
            `Organización ${plan.organizacion}`
          }
        >
          <span>{plan.tipo_plan}</span>
        </Tooltip>
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>{plan.precio}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>{plan.duracion}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        {plan.creditos_mensuales}
      </StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>{plan.total_creditos}</StyledTableCell>
      <StyledTableCell>{plan.max_usuarios}</StyledTableCell>
      <StyledTableCell sx={{ mb: 4 }}>
        {isSuperAdmin ? (
          <Switch
            checked={isActive}
            onChange={toggleActive}
            sx={{
              "& .MuiSwitch-switchBase.Mui-checked": {
                color: "#2E7D32",
              },
              "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
                backgroundColor: "#2E7D32",
              },
            }}
          />
        ) : (
          plan.estado
        )}
      </StyledTableCell>
      <StyledTableCell
        align="center"
        sx={{ display: "flex", flexDirection: "row" }}
      >
        {isSuperAdmin && (
          <Button sx={{ color: "#336B87" }} onClick={() => handleEdit(plan)}>
            <Tooltip title="Editar plan">
              <IconButton aria-label="edit" sx={{ color: "#336B87" }}>
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Button>
        )}
        {isSuperAdmin && (
          <Button
            sx={{ color: "#336B87" }}
            onClick={() => assignToDeletePlan(plan.id_plan)}
          >
            <Tooltip title="Eliminar plan">
              <IconButton aria-label="delete" sx={{ color: "#336B87" }}>
                <DeleteOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Button>
        )}
        <Button sx={{ color: "#336B87" }} onClick={handleNavigate}>
          <Tooltip title="Ver plan">
            <IconButton aria-label="usuarios" sx={{ color: "#336B87" }}>
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </Button>
      </StyledTableCell>
    </StyledTableRow>
  );
};
